import React, { useEffect, useState } from 'react';

import callImg from "../../images/call_3_1x.png"

const RedirectToMail = () => {
  const [mail, setMail] = useState(null);

  // Функция для извлечения номера телефона из URL
  const getMailFromUrl = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const mailAddress = urlParams.get('email');
    return mailAddress ? mailAddress.trim() : null;
  };

  // Перенаправление на tel: с номером телефона
  const redirectMail = (mailAddress) => {
    if (mailAddress) {
      window.location.href = `mailto:${mailAddress}`;
    }
  };

  useEffect(() => {
    const mailAddress = getMailFromUrl();
    setMail(mailAddress);
    redirectMail(mailAddress);
  }, []);

  return (
    <div className='mail-container'>
      <p>
        Если почта не открылась автоматически,{' '}
        <a id="phoneLink" href={`mailto:${mail || ''}`}>
          нажмите здесь
        </a>.
      </p>

      <img src={callImg} alt="" className="img-call"/>

    </div>
  );
};

export default RedirectToMail;
